import { jsx as _jsx } from "react/jsx-runtime";
import { CardFull } from '@aviv-classified-card/card/full';
import { Box } from '@gemini/core';
import { FavoriteHeart } from '../FavoriteHeart';
export const BaseCard = ({ id, queryString, listName, testId, serpView, trackingEvent, onPointerEnter, onPointerLeave, isCardXXL = false, }) => {
    const urlParams = {
        ln: listName,
        serp_view: serpView,
        ...(queryString.length > 0 && { search: queryString }),
    };
    return (_jsx(Box, { id: `classified-card-${id}`, testId: testId, onClick: trackingEvent, onPointerEnter: onPointerEnter, onPointerLeave: onPointerLeave, children: _jsx(CardFull, { id: id, cdpUrlParams: urlParams, actionSlot: _jsx(FavoriteHeart, { id: id, listName: listName }), isCardXXL: isCardXXL }) }));
};
